import { CornerDownLeft, Gauge } from 'lucide-react';

/**
 * A one-tap offer to fill the mileage box with the vehicle's last MOT
 * odometer reading.
 *
 * It is an OFFER, never a pre-fill: what lands in the box is saved as the
 * vehicle's mileage, and a reading from a test up to a year old is not
 * today's mileage. So the mechanic has to choose it, and it has to look like
 * something you can choose: a full-width button with the figure, its date and
 * a "Use" action, not a line of small print.
 */
export function MotMileageOffer({
    miles,
    testDate,
    onUse,
}: {
    miles: number;
    testDate: string | null;
    onUse: () => void;
}) {
    const when = testDate
        ? new Date(testDate).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })
        : null;
    return (
        <button type="button" onClick={onUse} className="fd-offer" aria-label={`Use the last MOT reading, ${miles.toLocaleString('en-GB')} miles${when ? `, from ${when}` : ''}`}>
            {/* Two lines so it fits a half-width column on a phone: what it
                is, then the figure with its action. */}
            <span className="fd-offer-label">
                <Gauge aria-hidden="true" />
                <span>Last MOT{when ? ` · ${when}` : ''}</span>
            </span>
            <span className="fd-offer-row">
                <span className="font-mono font-semibold text-fg tabular-nums">
                    {miles.toLocaleString('en-GB')} mi
                </span>
                <span className="fd-offer-action" aria-hidden="true">
                    Use <CornerDownLeft />
                </span>
            </span>
        </button>
    );
}
